/**
 * Copyright © Veeam Software Group GmbH.
 */

import * as React from 'react';
import {
    SPACE_FILL,
    STACK_DIRECTION,
    STACK_GAP,
    StackView,
    TitleH1,
} from '@veeam-vspc/components';

import { useLang } from 'views/providers/LangProvider/hooks';

export const ProductUpdatesSection: React.FC = (props) => {
    const lang = useLang();

    return (
        <StackView
            direction={STACK_DIRECTION.column}
            spaceFill={SPACE_FILL.all}
            gap={STACK_GAP.s}
            className='product-updates-section'
        >
            <TitleH1>
                {lang.PRODUCT_UPDATES}
            </TitleH1>

            {props.children}
        </StackView>
    );
};
